import { FlagsComponentRouter, FlagsSingleton } from 'flags'

import OffComponent from './flag.off/index'
import OnComponent from './flag.on/index'
import { isMiddleSchoolPage, isK5SiteSelection } from 'utils/productHelpers'

// TODO REMOVE MIDDLE SCHOOL JUNE RELEASE: middle school june release allows us to keep this flag checker on. So DO NOT turn off or remve this flag
// until we have a replacement for it. Used in multiple places so update all of them at once
const FlagToggler = FlagsComponentRouter({
  flagSubscriptions: [
    'middle-school-june-release',
    'feature_LEARN-20164-k5-site-selection',
  ],
  OnComponent,
  OffComponent,
  flagsChecker: FlagsSingleton.checkAtLeastOneFlagTrue,
  onCondition: (_, subscribedFlags) =>
    isMiddleSchoolPage() || isK5SiteSelection(_, subscribedFlags),
})

export default FlagToggler
